export enum VerificatieBerekeningScore {
    Voldoet = '1',
    VoldoetNiet = '6',
}
